/**
 * useBackInStockNotifications
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'
import BackInStockNotificationsContext from './back-in-stock-notifications-context'

const useBackInStockNotifications = () => {
  const context = useContext(BackInStockNotificationsContext)
  return context
}

export default useBackInStockNotifications
